import { Button } from "@mui/material";
import styles from "./TextComponent.module.scss";
import { getTextComponentStyles } from "./TextComponent.styles";

export interface TextComponentProps {
  text: string;
  fontSize: string;
  color: "primary" | "secondary";
  uppercase?: boolean;
  underline?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  dark?: boolean;
  noPadding?: boolean;
  lightFont?: boolean;
}

function TextComponent(props: TextComponentProps) {
  const {
    text,
    fontSize,
    underline,
    color,
    uppercase,
    disabled,
    onClick,
    dark,
    noPadding,
    lightFont,
  } = props;

  const TextComponentStyles = getTextComponentStyles(
    color,
    underline,
    uppercase,
    dark
  );
  return (
    <Button
      disableRipple
      className={`${styles.textComponent} ${noPadding ? styles.noPadding : ""}`}
      sx={{ ...TextComponentStyles, padding: noPadding ? "0" : "0 0.5rem" }}
      disabled={disabled}
      onClick={onClick}
    >
      <p
        className={`${fontSize} ${styles.textComponentLabel} ${
          lightFont ? styles.lightFont : ""
        }`}
      >
        {text}
      </p>
    </Button>
  );
}

export default TextComponent;
